export default () => '/traditional-login';
